<template>
  <v-layout row wrap justify-center>
    <v-dialog v-model="dialog" persistent max-width="580">
      <v-card class="py-3">
        <v-flex xs12 class="text-xs-center">
          <v-card-title class="title font-weight-bold d-inline-block"
            >{{ lang.rating_agreement_form_title }}
          </v-card-title>
        </v-flex>
        <v-card-text>
          <v-layout row wrap>
            <v-flex class="text-xs-left px-3" xs12>
              <v-flex class="pb-4">
                <p>{{ lang.this_contents_may_contain_sensitive_expression }}</p>
                <p v-html="sensitiveHint"></p>
              </v-flex>
            </v-flex>
            <v-flex class="text-xs-center">
              <v-flex class="pb-3">
                <v-flex class="mb-3">
                  <v-btn
                    @click="agree"
                    style="width: 100px;"
                    :loading="isLoading"
                    :disabled="isLoading"
                  >
                    {{ lang.button_text_yes }}
                  </v-btn>
                </v-flex>
                <v-flex>
                  <v-btn
                    style="width: 100px;"
                    @click="disagree"
                    :href="disagreeUrl"
                    :loading="isLoading"
                    :disabled="isLoading"
                  >
                    {{ lang.button_text_no }}
                  </v-btn>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "vc-share-rating-agreement-form",
  data() {
    return {
      dialog: true,
      isLoading: false
    };
  },
  props: {
    disagreeUrl: {
      type: String,
      default: ""
    },
    code: {
      type: String,
      default: ""
    },
    ratingStandardsUrl: {
      type: String,
      default: ""
    },
    lang: {
      Type: Object,
      default: () => {
        return {
          rating_agreement_form_title: "確認",
          this_contents_may_contain_sensitive_expression:
            "性的、グロテスク、残酷など、センシティブな表現が含まれている可能性があります。",
          this_contents_is_self_regulated:
            "※この作品は自主規制されています。:a_startレーティング基準表:a_endを参考に18歳未満の青少年に見せてよいかどうかを基準として、制作者の判断によって設定されています。",
          button_text_yes: "閲覧する",
          button_text_no: "キャンセル"
        };
      }
    },
    postRatingAgreements: {
      type: Function,
      default: () => {}
    }
  },
  created: function() {
    this.sensitiveHint =
      '<span class="caption">' +
      this.lang.this_contents_is_self_regulated
        .replace(
          ":a_start",
          '<a href="' +
            this.ratingStandardsUrl +
            '" id="sensitiveHintDom" target="_self">'
        )
        .replace(":a_end", "</a>") +
      "</span>";
  },
  methods: {
    disagree: function() {
      this.isLoading = true;
      location.href = this.disagreeUrl;
    },
    agree: function() {
      this.isLoading = true;

      let requestData = {
        code: this.code
      };

      this.postRatingAgreements(requestData).then(value => {
        if (value === 0) {
          location.reload();
        }

        this.isLoading = false;
      });
    }
  }
};
</script>
